import { CAMPAIGN_STATUSES, CHANNEL_COLORS } from '@/utils/campaignOptions'
import { mapMutations, mapState } from 'vuex'
import { MODULE_NAME, MUTATIONS } from '@/store/filters/constants'
import { MODULE_NAME as MODULE_NAME_CAMPAIGNS } from '@/store/campaigns/constants'
import moment from 'moment'
import { TASK_STATUSES } from '@/api/campaignsService'

export default {
  name: 'Header',
  mixins: [],
  components: {
    Filters: () => import(/* webpackChunkName: "Filters" */ '@/components/filters/Filters.vue'),
    FulltextSearch: () => import(/* webpackChunkName: "FulltextSearch" */ '@/components/fulltext-search/FulltextSearch.vue'),
    UserDropdown: () => import(/* webpackChunkName: "UserDropdown" */ '@/components/user-dropdown/UserDropdown.vue'),
    TasksMenu: () => import(/* webpackChunkName: "TasksMenu" */ '@/components/tasks-menu/TasksMenu.vue')
  },
  props: {},
  data () {
    return {
      backgroundColor: 'transparent',
      datepickerDate: null,
      onlyMonthSelection: false,
      TASK_STATUSES
    }
  },
  computed: {
    ...mapState(MODULE_NAME, ['filters']),
    ...mapState(MODULE_NAME_CAMPAIGNS, {
      tasks: 'copy_tasks'
    }),
    activeCampaigns () {
      const filter = this.filters.find(f => f.key === 'campaign_status')
      return filter.value === CAMPAIGN_STATUSES.ACTIVE
    },
    startDateFilter () {
      return this.filters.find(f => f.key === 'start_date')
    },
    finishDateFilter () {
      return this.filters.find(f => f.key === 'finish_date')
    },
    className () {
      const route = this.$route.matched.find(m => m.meta.header)
      const className = route ? route.meta.header : 'default'
      return className
    },
    iconColor () {
      const meta = this.$route.matched.find(m => m.meta.iconColor)
      const color = meta ? meta.meta.iconColor : '#1a1e29'
      return color
    },
    canShowDatePicker () {
      return this.$route.matched.some(m => m.meta.showDatePicker)
    },
    canShowFilters () {
      return !this.$route.matched.some(m => m.meta.noFilters)
    },
    canShowToggle () {
      return this.$route.matched.some(m => m.meta.showActiveToggle)
    },
    canShowSearch () {
      return !this.$route.matched.some(m => m.meta.hideSearch)
    },
    canShowTasks () {
      return this.tasks.results.length && this.$route.matched.some(m => m.meta.showTasks)
    },
    taskListStatus () {
      if (this.tasks.results.some(t => t.status === TASK_STATUSES.FAILED)) {
        return TASK_STATUSES.FAILED
      }
      if (this.tasks.results.every(t => t.status === TASK_STATUSES.COMPLETED)) {
        return TASK_STATUSES.COMPLETED
      }
      return TASK_STATUSES.RUNNING
    },
    noScroll () {
      return this.$route.matched.some(m => m.meta.noScroll)
    },
    channelType () {
      return this.$route.params.type
    },
    useChannelType () {
      return this.$route.matched.some(m => m.meta.headerFromChannelType)
    },
    headerColor () {
      return this.useChannelType ? CHANNEL_COLORS[this.channelType] : null
    },
    style () {
      return this.noScroll ? null : { backgroundColor: this.backgroundColor }
    }
  },
  watch: {
    headerColor () {
      this.setBackground()
    },
    // TODO: dev testing
    '$route.name' () {
      if (!this.canShowSearch) {
        this[MUTATIONS.SET_FILTER_VALUE]({ key: 'fulltext', value: '' })
      }
      this.setDatepicker()
    }
  },
  created () {
    this.setDatepicker()
  },
  mounted () {
    this.setBackground()
    window.addEventListener('scroll', this.setBackground, false)
  },
  beforeDestroy () {
    this[MUTATIONS.CLEAR_ALL_FILTERS]()
    window.removeEventListener('scroll', this.setBackground, false)
  },
  methods: {
    ...mapMutations(MODULE_NAME, [
      MUTATIONS.SET_FILTER_VALUE,
      MUTATIONS.CLEAR_ALL_FILTERS
    ]),
    setBackground () {
      this.backgroundColor = window.pageYOffset < 65 ? 'transparent' : this.headerColor
    },
    onDatepickerChange (dates) {
      const [start, finish] = dates

      // Persist datepicker state between routes (if it's not the billing route)
      if (this.$route.name !== 'billing') {
        this[MUTATIONS.SET_FILTER_VALUE]({ key: 'start_date_global', value: start })
        this[MUTATIONS.SET_FILTER_VALUE]({ key: 'finish_date_global', value: finish })
      }

      this[MUTATIONS.SET_FILTER_VALUE]({ key: 'start_date', value: start })
      this[MUTATIONS.SET_FILTER_VALUE]({ key: 'finish_date', value: finish })
    },
    toggleActiveCampaigns ({ state }) {
      this[MUTATIONS.SET_FILTER_VALUE]({
        key: 'campaign_status',
        value: state ? CAMPAIGN_STATUSES.ACTIVE : null
      })
    },
    closeAll () {
      if (this.$refs.userDropdown) {
        this.$refs.userDropdown.shopListExpanded = false
      }
    },
    closeUserDropdown () {
      this.$refs.dropdown.close()
    },
    setDatepicker () {
      if (this.$route.name === 'billing') {
        const startDate = moment().startOf('month').subtract(1, 'month').toDate()
        const endDate = moment().endOf('month').subtract(1, 'month').toDate()
        this.datepickerDate = [startDate, endDate]
        this.onDatepickerChange(this.datepickerDate)
        this.onlyMonthSelection = true
      } else {
        // Persist datepicker state between routes (if it's not the billing route)
        const startDate = this.filters.find(x => x.key === 'start_date_global').value // moment().startOf('year').add(12, 'hour').toDate()
        const endDate = this.filters.find(x => x.key === 'finish_date_global').value // moment().endOf('year').toDate()
        this.datepickerDate = [startDate, endDate]
        this.onDatepickerChange(this.datepickerDate)
        this.onlyMonthSelection = false
      }
    },
    onToggleTaskMenu () {
      setTimeout(() => {
        if (this.$refs.tasksMenu) this.$refs.tasksMenu.updateScrollbar()
      }, 500)
    }
  }
}
